import React, { useEffect, useState } from 'react';
import axios from '../../../../../libs/axios';
import { Card, Form, Button, Row, Col, Alert, Spinner, Table } from 'react-bootstrap';

// Item 9 — Penempatan (medan berasingan, bukan jadual offices).
const PENEMPATAN_OPTIONS = [
    'Ibu Pejabat BPN',
    'Ibu Pejabat BPH',
    'Unit Pengurusan Penguatkuasaan PAID',
    'Bahagian Pengurusan Halal',
];

const PpaProfileComponent = () => {
    const url = process.env.REACT_APP_API_URL + '/account/profile';
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState(null); // { type, text }
    const [staff, setStaff] = useState(null);
    const [role, setRole] = useState('');
    const [form, setForm] = useState({
        grade: '',
        department: '',
        no_tel_pejabat: '',
        address: '',
        marital_status: '',
        phone: '',
    });

    useEffect(() => {
        setLoading(true);
        axios({ method: 'get', url })
            .then((res) => {
                const s = res?.data?.staff || null;
                setStaff(s);
                setRole(res?.data?.role || '');
                if (s) {
                    setForm({
                        grade: s.grade || '',
                        department: s.department || '',
                        no_tel_pejabat: s.no_tel_pejabat || '',
                        address: s.address || '',
                        marital_status: s.marital_status || '',
                        phone: s.phone || '',
                    });
                }
            })
            .catch((err) => {
                setMessage({ type: 'danger', text: err?.response?.data?.message || 'Gagal memuatkan profil.' });
            })
            .finally(() => setLoading(false));
    }, [url]);

    const onChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const onSubmit = (e) => {
        e.preventDefault();
        setSaving(true);
        setMessage(null);
        axios({ method: 'put', url, data: form })
            .then((res) => {
                setMessage({ type: 'success', text: res?.data?.message || 'Profil berjaya dikemaskini.' });
                if (res?.data?.staff) {
                    setStaff(res.data.staff);
                }
            })
            .catch((err) => {
                setMessage({ type: 'danger', text: err?.response?.data?.message || 'Gagal kemaskini profil.' });
            })
            .finally(() => setSaving(false));
    };

    if (loading) {
        return (
            <div className="mt-4">
                <Spinner animation="border" size="sm" /> Memuatkan profil PPA...
            </div>
        );
    }

    if (!staff) {
        return (
            <Alert variant="warning" className="mt-4" style={{ maxWidth: '1000px' }}>
                Tiada rekod kakitangan dipautkan kepada akaun ini. Sila hubungi admin.
            </Alert>
        );
    }

    const readonlyRow = (label, value) => (
        <tr>
            <th style={{ width: '260px' }}>{label}</th>
            <td>{value ? value : <span className="text-muted">&mdash;</span>}</td>
        </tr>
    );

    return (
        <div className="mt-4" style={{ maxWidth: '1000px' }}>
            <h2>Maklumat Profil PPA</h2>

            <Card className="mb-3">
                <Card.Header className="fw-bold">
                    Maklumat Peribadi Kakitangan (dikunci &mdash; admin sahaja)
                </Card.Header>
                <Card.Body>
                    <Table bordered size="sm" className="mb-2">
                        <tbody>
                            {readonlyRow('1. Nama PPA', staff.name)}
                            {readonlyRow('2. No. IC', staff.ic_number)}
                            {readonlyRow('3. No. Badan PPA (ID)', staff.staff_id)}
                            {readonlyRow('4. Pekerjaan', staff.position)}
                            {readonlyRow('5. Alamat Pejabat', staff.office_address)}
                            {readonlyRow('6. Emel Akses', staff.email)}
                            {readonlyRow('7. Role Akses', (role || '').toUpperCase())}
                        </tbody>
                    </Table>
                    <small className="text-muted">
                        Medan 1&ndash;7 hanya boleh dikemaskini oleh admin. Hubungi admin jika perlu pembetulan.
                    </small>
                </Card.Body>
            </Card>

            <Card>
                <Card.Header className="fw-bold">Tambahan Maklumat (anda boleh kemaskini)</Card.Header>
                <Card.Body>
                    {message ? <Alert variant={message.type}>{message.text}</Alert> : null}
                    <Form onSubmit={onSubmit}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>8. Jawatan &amp; Gred</Form.Label>
                                <Form.Control
                                    value={form.grade}
                                    onChange={(e) => onChange('grade', e.target.value)}
                                    placeholder="cth S1 / S2 / KUPD"
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label>9. Penempatan</Form.Label>
                                <Form.Select value={form.department} onChange={(e) => onChange('department', e.target.value)}>
                                    <option value="">-- Pilih Penempatan --</option>
                                    {PENEMPATAN_OPTIONS.map((o) => (
                                        <option key={o} value={o}>{o}</option>
                                    ))}
                                    {form.department && !PENEMPATAN_OPTIONS.includes(form.department) ? (
                                        <option value={form.department}>{form.department}</option>
                                    ) : null}
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>10. No. Tel Pejabat</Form.Label>
                                <Form.Control
                                    value={form.no_tel_pejabat}
                                    onChange={(e) => onChange('no_tel_pejabat', e.target.value)}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label>13. No. Tel Peribadi (HP)</Form.Label>
                                <Form.Control value={form.phone} onChange={(e) => onChange('phone', e.target.value)} />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Label>11. Alamat Rumah</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={form.address}
                                    onChange={(e) => onChange('address', e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>12. Status</Form.Label>
                                <Form.Select
                                    value={form.marital_status}
                                    onChange={(e) => onChange('marital_status', e.target.value)}
                                >
                                    <option value="">-- Pilih Status --</option>
                                    <option value="Bujang">Bujang</option>
                                    <option value="Berkahwin">Berkahwin</option>
                                    {form.marital_status && !['Bujang', 'Berkahwin'].includes(form.marital_status) ? (
                                        <option value={form.marital_status}>{form.marital_status}</option>
                                    ) : null}
                                </Form.Select>
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" disabled={saving}>
                            {saving ? 'Menyimpan...' : 'Simpan'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default PpaProfileComponent;
